<template>
  <v-app>
    <router-view></router-view>
    <!-- loading -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- notification -->
    <v-snackbar
      v-for="notification in notifications" :key="notification.id"
      :timeout="notification.timeout"
      :color="notification.type"
      top center
      @input="removeNotification(notification)"
      :value="true"
    >
      {{ notification.message }}
      <v-btn icon @click.native="removeNotification(notification)" dark>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState(['overlay', 'buTabs', 'token']),
    ...mapState('notifications', { notifications: 'stack' }),
  },
  created() {
    if (this.buTabs === null) {
      this.getBus().then((data) => {
        this.setBuTabs(data);
      });
    }
  },
  watch: {
    token(val) {
      if (val !== '' || val === null) {
        if (this.buTabs === null) {
          this.getBus().then((data) => {
            this.setBuTabs(data);
          });
        }
      }
    },
  },
  methods: {
    ...mapActions(['setOverlay', 'setBuTabs']),
    ...mapActions('notifications', { removeNotification: 'remove' }),
    ...mapActions('bupage', { getBus: 'all' }),
  },
  mounted() {
    this.setOverlay(true);
    setTimeout(() => this.setOverlay(false), 1000);
  },
};
</script>

<style lang="scss">
// @import '@/assets/scss/main.scss';
</style>
